"use client";

import React from "react";
import { motion } from "motion/react";
import Link from "next/link";
import { Button } from "@/common/components/ui/button";
import MainLayout from "@/common/layout/Main";
import { BackgroundCompleteIcon } from "./components/background-complete-icon";
import { FourIcon } from "./components/four-icon";
import { MagnifireIcon } from "./components/magnifire-icon";
import { StarsIcon } from "./components/stars-icon";
import NotFoundFooter from "./not-found-footer";
import { NotFoundHeader } from "./not-found-header";
const NotFoundContainer = () => {
  return <div className="overflow-hidden" data-sentry-component="NotFoundContainer" data-sentry-source-file="index.tsx">
      <NotFoundHeader data-sentry-element="NotFoundHeader" data-sentry-source-file="index.tsx" />
      <MainLayout data-sentry-element="MainLayout" data-sentry-source-file="index.tsx">
        <div className="flex h-[80vh] flex-col items-center justify-center">
          <div className="relative h-[267px] w-[269px]">
            <div className="absolute">
              <BackgroundCompleteIcon data-sentry-element="BackgroundCompleteIcon" data-sentry-source-file="index.tsx" />
            </div>
            <div className="absolute">
              <StarsIcon data-sentry-element="StarsIcon" data-sentry-source-file="index.tsx" />
            </div>
            <div className="absolute right-2 top-1/4">
              <FourIcon data-sentry-element="FourIcon" data-sentry-source-file="index.tsx" />
            </div>
            <div className="absolute left-2 top-1/4 z-10">
              <FourIcon data-sentry-element="FourIcon" data-sentry-source-file="index.tsx" />
            </div>
            <motion.div animate={{
            y: -100,
            rotate: 60
          }} transition={{
            repeat: Infinity,
            repeatType: "mirror",
            duration: 4,
            repeatDelay: 0
          }} className="absolute right-1/4 top-[30%] -translate-x-1/2 -translate-y-1/2" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
              <MagnifireIcon data-sentry-element="MagnifireIcon" data-sentry-source-file="index.tsx" />
            </motion.div>
          </div>
          <div className="mb-6 mt-4 flex flex-col items-center justify-center gap-2">
            <p className="text-base font-bold text-gray-600">
              صفحه مورد نظر پیدا نشد!
            </p>
            <p className="text-center text-sm font-medium leading-relaxed text-gray-600">
              آدرس این صفحه اشتباه است و یا دیگر وجود ندارد.
              <br /> می‌توانید از صفحه خانه شروع کنید.
            </p>
          </div>
          <Link href="/" className="w-full" replace data-sentry-element="Link" data-sentry-source-file="index.tsx">
            <Button variant="filled" className="w-full" data-sentry-element="Button" data-sentry-source-file="index.tsx">
              بازگشت به خانه
            </Button>
          </Link>
        </div>
      </MainLayout>
      <NotFoundFooter data-sentry-element="NotFoundFooter" data-sentry-source-file="index.tsx" />
    </div>;
};
export default NotFoundContainer;